import React, { useState, useEffect, useCallback } from "react";
import { Col, Container, Form, FormFeedback, Input, Modal, ModalBody, ModalHeader, Row, Table } from "reactstrap";
import { ToastContainer } from "react-toastify";
import DeleteModal from "./DeleteModal";
import Dragula from "react-dragula";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";

const CadastroPadrao = ({
  titulo,
  labelSingular,
  reduxKey,
  acoesRedux,
  colunas,
  camposFormulario
}) => {
  const dispatch = useDispatch();
  const dados = useSelector((state) => state[reduxKey][reduxKey]);

  const [deleteModal, setDeleteModal] = useState(false);
  const [itemSelecionado, setItemSelecionado] = useState(null);
  const [modalAberto, setModalAberto] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  const refreshData = async () => {
    setLoading(true);
    try {
      await dispatch(acoesRedux.onGet()).unwrap();
    } catch (error) {
      console.error('Erro ao atualizar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(acoesRedux.onGet())
      .unwrap()
      .then(() => {
        console.log('✅ Dados carregados com sucesso');
      })
      .catch((e) => {
        console.error('❌ Erro ao buscar:', e);
      });
  }, [dispatch]);

  const toggle = useCallback(() => {
    setModalAberto(!modalAberto);
  }, [modalAberto]); 
  
  const handleEditar = (item) => {
    setIsEdit(true);
    setItemSelecionado(item); // Primeiro define o item
    setModalAberto(true); // Depois abre o modal sem chamar toggle()
  };

  const handleNovo = () => {
    setIsEdit(false);
    setItemSelecionado(null); // Reset manual apenas para novo item
    setModalAberto(true);
  };

  const handleDelete = () => {
    if (itemSelecionado) {
      dispatch(acoesRedux.onDelete(itemSelecionado.id))
        .unwrap()
        .then(() => {
          dispatch(acoesRedux.onGet()); // Busca os dados atualizados
          setDeleteModal(false);
        })
        .catch(error => {
          console.error('Erro ao excluir:', error);
        });
    }
  };
  const dragulaDecorator = (componentBackingInstance) => {
    if (componentBackingInstance) {
      Dragula([componentBackingInstance], {});
    }
  };

  const searchList = (e) => {
    const valorBusca = e.toLowerCase();
    const filtrado = dados.filter((el) => el.nome.toLowerCase().includes(valorBusca));

    if (filtrado.length === 0) {
      document.getElementById("noresult").style.display = "block";
      document.getElementById("lista").style.display = "none";
    } else {
      document.getElementById("noresult").style.display = "none";
      document.getElementById("lista").style.display = "block";
    }
  };

  useEffect(() => {

  }, [dados]);

  const initialValues = {};
  const validacoes = {};
  camposFormulario.forEach((campo) => {
    initialValues[campo.nome] = itemSelecionado ? itemSelecionado[campo.nome] || "" : "";
    validacoes[campo.nome] = campo.validacao;
  });

  
  
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: camposFormulario.reduce((acc, campo) => {
      // Tratamento especial para booleanos
      acc[campo.nome] = itemSelecionado 
        ? campo.tipo === 'checkbox' 
          ? Boolean(itemSelecionado[campo.nome])
          : itemSelecionado[campo.nome] || ""
        : campo.tipo === 'checkbox'
          ? false
          : "";
      return acc;
    }, {}),
    validationSchema: Yup.object(
      camposFormulario.reduce((acc, campo) => {
        acc[campo.nome] = campo.validacao;
        return acc;
      }, {})
    ),
    onSubmit: (values) => {
      const operation = isEdit 
        ? dispatch(acoesRedux.onUpdate({ ...itemSelecionado, ...values }))
        : dispatch(acoesRedux.onAddNew({ id: Date.now().toString(), ...values }));
  
      operation
        .unwrap()
        .then(() => {
          dispatch(acoesRedux.onGet()); // Busca os dados atualizados
          toggle();
          validation.resetForm();
        })
        .catch(error => {
          console.error('Erro na operação:', error);
        });
    }
  });

  useEffect(() => {
    
  }, [itemSelecionado, validation.values, isEdit]);


  return (
    <>
      <ToastContainer closeButton={false} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
        <Container fluid>
          <div className="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1">
            <div className="file-manager-content w-100 p-4 pb-0">
              <Row className="mb-4">
                <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                  <h5 className="fw-semibold mb-0">Lista de {titulo}</h5>
                </div>
              </Row>

              <div className="p-3 bg-light rounded mb-4">
                <Row className="g-2">
                  <Col className="col-lg">
                    <div className="search-box">
                      <input type="text" className="form-control search" placeholder={`Pesquise por ${labelSingular}`} onKeyUp={(e) => searchList(e.target.value)} />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                  <Col className="col-lg-auto">
                    <button className="btn btn-primary" type="button" onClick={handleNovo}>
                      <i className="ri-add-fill align-bottom" /> Adicionar
                    </button>
                  </Col>
                </Row>
              </div>

              <div className="todo-content position-relative px-4 mx-n4" id="todo-content">
                {!dados && (
                  <div id="elmLoader">
                    <div className="spinner-border text-primary avatar-sm" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}

                <div  id="lista">
                  {loading && (
                    <div className="text-center py-3">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Carregando...</span>
                      </div>
                    </div>
                  )}
                  
                  {!loading && (
                    <div className="table-responsive mb-1">
                      <Table className="table align-middle table-nowrap" >
                          <thead className="table-light">
                          <tr>
                            {colunas.map((col) => <th className="sort" key={col.campo}>{col.titulo}</th>)}
                            <th>Ação</th>
                          </tr>
                          </thead>
                          <tbody>
                          {(dados || []).map((item, key) => (
                            <tr key={key}>
                              {colunas.map((col) => (
                                  <td key={col.campo}>
                                  {typeof item[col.campo] === 'boolean' 
                                    ? item[col.campo] ? 'Sim' : 'Não' 
                                    : item[col.campo]}
                                </td>
                              ))}
                              <td>
                                <div className="hstack gap-2">
                                  <button className="btn btn-sm btn-soft-danger" onClick={() => { setItemSelecionado(item); setDeleteModal(true); }}>
                                    <i className="ri-delete-bin-5-fill align-bottom" />
                                  </button>
                                  <button className="btn btn-sm btn-soft-info" onClick={() => handleEditar(item)}>
                                    <i className="ri-pencil-fill align-bottom" />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                              
                          
                      </Table>
                    </div>
                    )}
                </div>

                <div className="py-4 mt-4 text-center" id="noresult" style={{ display: "none" }}>
                  <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{ width: "72px", height: "72px" }}></lord-icon>
                  <h5 className="mt-4">Nenhum resultado encontrado</h5>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>

      
<Modal isOpen={modalAberto} toggle={toggle}>
  <ModalHeader toggle={toggle}>
    {isEdit ? `Editar ${labelSingular}` : `Adicionar ${labelSingular}`}
  </ModalHeader>
  {/* <ModalBody>
    {(!isEdit || (isEdit && itemSelecionado)) ? (
      <Form onSubmit={validation.handleSubmit}>
        {camposFormulario.map((campo) => (
          <div className="mb-3" key={campo.nome}>
            <label htmlFor={`${campo.nome}-input`} className="form-label">
              {campo.label}
            </label>
            <Input
              type="text"
              id={`${campo.nome}-input`}
              name={campo.nome}
              placeholder={campo.placeholder}
              value={validation.values[campo.nome] || ""}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              invalid={
                validation.touched[campo.nome] && validation.errors[campo.nome]
                  ? true
                  : false
              }
            />
            {validation.touched[campo.nome] && validation.errors[campo.nome] ? (
              <FormFeedback type="invalid">
                {validation.errors[campo.nome]}
              </FormFeedback>
            ) : null}
          </div>
        ))}
        <div className="hstack gap-2 justify-content-end">
          <button type="button" className="btn btn-ghost-success" onClick={() => {
  setModalAberto(false);
  setItemSelecionado(null); // Reset manual ao fechar
}}>
            <i className="ri-close-fill align-bottom"></i> Fechar
          </button>
          <button type="submit" className="btn btn-primary">
            {isEdit ? "Salvar" : `Adicionar ${labelSingular}`}
          </button>
        </div>
      </Form>
    ) : (
      <div>Carregando...</div>
    )}
  </ModalBody> */}
  <ModalBody>
  {(!isEdit || (isEdit && itemSelecionado)) ? (
    <Form onSubmit={validation.handleSubmit}>
      {camposFormulario.map((campo) => (
        <div className="mb-3" key={campo.nome}>
          {campo.tipo === 'checkbox' ? (
            <div className="form-check">
              <Input
                type="checkbox"
                id={`${campo.nome}-input`}
                name={campo.nome}
                className="form-check-input"
                checked={validation.values[campo.nome] || false}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
              />
              <label htmlFor={`${campo.nome}-input`} className="form-check-label">
                {campo.label}
              </label>
              {validation.touched[campo.nome] && validation.errors[campo.nome] ? (
                <div className="invalid-feedback d-block">
                  {validation.errors[campo.nome]}
                </div>
              ) : null}
            </div>
          ) : (
            <>
              <label htmlFor={`${campo.nome}-input`} className="form-label">
                {campo.label}
              </label>
              <Input
                type="text"
                id={`${campo.nome}-input`}
                name={campo.nome}
                placeholder={campo.placeholder}
                value={validation.values[campo.nome] || ""}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                invalid={validation.touched[campo.nome] && validation.errors[campo.nome] ? true : false}
              />
              {validation.touched[campo.nome] && validation.errors[campo.nome] ? (
                <FormFeedback type="invalid">{validation.errors[campo.nome]}</FormFeedback>
              ) : null}
            </>
          )}
        </div>
      ))}
       <div className="hstack gap-2 justify-content-end">
          <button type="button" className="btn btn-ghost-success" onClick={() => {
            setModalAberto(false);
            setItemSelecionado(null); // Reset manual ao fechar
          }}>
            <i className="ri-close-fill align-bottom"></i> Fechar
          </button>
          <button type="submit" className="btn btn-primary">
            {isEdit ? "Salvar" : `Adicionar ${labelSingular}`}
          </button>
        </div>
      </Form>
    ) : (
      <div>Carregando...</div>
    )}
</ModalBody>
</Modal>
    </>
  );
};

export default CadastroPadrao;
